exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panels div{padding:0;margin:0}.panels .list-group-item{padding:20px}.page-header,.table-header{color:#fff}.loading{margin-top:5px}.loading span.text{line-height:25px;height:25px;display:inline-block;position:absolute;margin-top:1px;margin-left:5px;color:#337ab7}.loading span.loader{display:inline-block;border:5px solid silver;border-top:5px solid #3498db;border-radius:50%;width:25px;height:25px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.offline{background-color:red}.offline,.online{color:#fff;font-size:13px}.online{background-color:green}.busy{background-color:#ff0;color:#000;font-size:13px}.table-header{font-size:17px}.search-field{width:70%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/styles.less
 ** module id = 624
 ** module chunks = 0
 **/